import { Link } from "@nulogy/components";
import styled from "styled-components";

const UnstyledLink = styled(Link)(({ theme, color }) => ({
  "&:hover": {
    color: color || theme.colors.darkBlue,
    textDecoration: "underline",
  },
  color: color || theme.colors.blue,
  fontWeight: "bold",
  textDecoration: "none",
}));

export default UnstyledLink;
